import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'frodo-mobile-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() isDisabled = false;
  @Input() labelKey: string;
  @Output() buttonClick = new EventEmitter<void>();

  onButtonClick(): void {
    this.buttonClick.emit();
  }
}
